export const DEFAULT_PLAN_TYPE = "all";

